import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { useAuth } from '../utils/auth.jsx';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:8000';

export function AuthGate({ children }) {
    const { token, login } = useAuth();
    const [input, setInput] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    if (token) {
        return children;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            // Verify the token against the backend
            const res = await fetch(`${API_BASE}/auth/verify`, {
                headers: { 'Authorization': `Bearer ${input}` }
            });
            if (res.ok) {
                login(input);
            } else {
                setError('Invalid access code');
            }
        } catch {
            setError('Cannot reach server');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-950 flex items-center justify-center p-4">
            <form onSubmit={handleSubmit} className="bg-gray-900 border border-gray-700 rounded-xl p-8 w-full max-w-sm space-y-4">
                <div className="flex items-center justify-center gap-2 text-white mb-2">
                    <Lock size={20} />
                    <h1 className="text-lg font-semibold">Access Required</h1>
                </div>
                <input
                    type="password"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    placeholder="Enter access code"
                    className="w-full px-4 py-2 bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    autoFocus
                />
                {error && <p className="text-red-400 text-sm">{error}</p>}
                <button
                    type="submit"
                    disabled={loading || !input}
                    className="w-full py-2 bg-blue-600 hover:bg-blue-500 disabled:opacity-50 text-white rounded-lg font-medium transition-colors"
                >
                    {loading ? 'Verifying...' : 'Enter'}
                </button>
            </form>
        </div>
    );
}
